/**
 * 设计器根容器上的固定叠层：左下角页面导航、右下角缩放菜单。
 * 定位均相对 designer-container（fixed inset-0），不再在 Workspace 内散落 fixed。
 */
import { cn } from '@heroui/react';
import { BottomLeftToolbar } from '../toolbars/BottomLeftToolbar';
import { BottomRightToolBar } from '../toolbars/BottomRightToolBar';
import { useWorkspaceChrome } from '@/components/canvas/workspace/stage/WorkspaceChromeContext';

export interface CanvasDesignerOverlaysProps {
  className?: string;
}

export function CanvasDesignerOverlays({ className }: CanvasDesignerOverlaysProps) {
  const chrome = useWorkspaceChrome();
  if (!chrome || chrome.isFullscreen) return null;

  return (
    <div className={cn('pointer-events-none absolute inset-0 z-[35]', className)}>
      <div className="pointer-events-none absolute bottom-4 left-4 z-[41]">
        <BottomLeftToolbar readonly={chrome.isReadonly} />
      </div>
      <div className="pointer-events-none absolute bottom-4 right-4 z-[41]">
        <BottomRightToolBar
          contentSize={chrome.contentSize}
          onFitToScreenRequest={chrome.onFitToScreenRequest}
        />
      </div>
    </div>
  );
}
